import {Injectable} from '@angular/core';
import {Repository} from '@app/@core/repositories/repository';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ReservesLeisureResponse} from '@app/models/v3/reserve-leisure';
import {format} from 'date-fns';
import {environment} from '@env/environment';
import {map} from 'rxjs/operators';
import {GetTransactionParam} from '@app/@core/repositories/reserve.repository';
import {Category, LeisureShop, PaidByEDCRequest, UpdatePartialRequest} from '@app/@core/domain/leisure.model';

@Injectable({
    providedIn: 'root'
})
export class  LeisureRepository extends Repository<any>{

    constructor(http: HttpClient) {
        super(http, 'category');
    }

    searchTransactionLeisure(param: Partial<GetTransactionParam>): Observable<ReservesLeisureResponse[]> {
        const params = {
            ...param,
            from: param.from ? format(param.from, 'yyyy-MM-dd') : '',
            to: param.from ? format(param.to, 'yyyy-MM-dd') : ''
        };

        if (!params.dateField) {
            console.error('(BE bug) dateField override to created');
            params.dateField = 'created';
        }

        // Bug dev not return array
        return this.http.get<any>(`${environment.api3Url}/api/internal/reserve-package/transaction`, {params}).pipe(
            map(r => {
                return r.success ? r.model ?? [] : r;
            })
        );
    }

    getReservesLeisureById(id: string): Observable<ReservesLeisureResponse> {
        return this.http.get<ReservesLeisureResponse>(`${environment.api3Url}/api/internal/reserve-package/${id}`);
    }

    getAllCategory(): Observable<Category[]> {
        return this.http.get<Category[]>(`${environment.api3Url}/api/internal/category/get-all`);
    }

    createCategory(form: Category): Observable<any> {
        return this.http.post<any>(`${environment.api3Url}/api/internal/category`, form);
    }

    updateCategory(form: Category): Observable<any> {
        return this.http.put<any>(`${environment.api3Url}/api/internal/category/${form.id}`, form);
    }

    deleteCategory(id: string): Observable<any> {
        return this.http.delete<any>(`${environment.api3Url}/api/internal/category/${id}` );
    }

    useRedeem(reserveId: string, itemId: string): Observable<ReservesLeisureResponse> {
        return this.http.get<ReservesLeisureResponse>(`${environment.api3Url}/api/internal/reserve-package/${reserveId}/redeem?itemId=${itemId}`);
    }

    getShopList(): Observable<LeisureShop[]> {
        return this.http.get<LeisureShop[]>(`${environment.api3Url}/api/internal/package-info/shop-search`);
    }

    manualPaidByEDC(reserveId: string, body: PaidByEDCRequest): Observable<any> {
      return this.http.post<any>(`${environment.api3Url}/api/internal/reserve-package/${reserveId}/manual-paid`, body);
    }

    updatePartialLeisure(reserveId: string, body: UpdatePartialRequest): Observable<ReservesLeisureResponse> {
      return this.http.put<ReservesLeisureResponse>(
        `${environment.api3Url}/api/internal/reserve-package/partial/${reserveId}`,
        body
      );
    }

    exportCSV(dateFrom: string, dateTo: string): Observable<Blob> {
      return this.http.get(`${environment.api3Url}/api/internal/reserve-package/export-csv?from=${dateFrom}&to=${dateTo}`, {
        responseType: 'blob'
      });
    }
}
